import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { productSlug } from '../../hooks/useProducts';
import { featureDefs, featuresFor } from '../../data/features/productFeatures';
import { featureIcons, BookIcon } from '../ui/GuideIcons';
import { ChevronRightIcon } from '../ui/Icons';
import { RichText, rich } from '../ui';
import './FeaturesTab.css';
/**
 * „Bedienung & Anzeige“: kurze Funktionskarten (Icon, ein bis zwei Sätze, Voraussetzung)
 * mit Link zur ausführlichen Anleitung.
 */
const FeaturesTab = ({ product }) => {
    const { t } = useTranslation();
    const items = featuresFor(productSlug(product));
    if (!items.length)
        return null;
    return (_jsxs("div", { className: "features-tab", children: [_jsx("ul", { className: "feature-cards", children: items.map(({ id, variant }) => {
                    const def = featureDefs[id];
                    const Icon = featureIcons[id] || BookIcon;
                    return (_jsxs("li", { className: "feature-card", children: [_jsx("span", { className: "icon-tile frame", children: _jsx(Icon, { size: 30 }) }), _jsxs("div", { className: "feature-body", children: [_jsx("h3", { children: t(`features.items.${id}.title`) }), _jsx("p", { children: rich(t(`features.items.${id}.${variant}`)) }), _jsxs("div", { className: "feature-foot", children: [def.requires?.map((r) => (_jsx("span", { className: "feature-req", children: t(`features.req.${r}`) }, r))), _jsxs(Link, { to: def.guide, className: "feature-more", children: [t('features.more'), _jsx(ChevronRightIcon, { size: 16 })] })] })] })] }, id));
                }) }), _jsx(RichText, { text: t('features.olderNote'), className: "feature-older" })] }));
};
export default FeaturesTab;
